// src/canonicalize.ts
var isValidNumber = (n) => {
  return typeof n === "number" && !isNaN(n) && n !== Infinity && n !== -Infinity;
};
var getValue = (json) => {
  return json === void 0 || typeof json === "symbol" ? null : json;
};
var canonicalize = (json) => {
  if (typeof json === "number" && !isValidNumber(json)) {
    throw new Error("canonicalize: cannot canonicalize non-number JSON");
  }
  if (json === void 0)
    return "null";
  if (json === null || typeof json !== "object") {
    return JSON.stringify(json);
  }
  if (json.toJSON instanceof Function) {
    return canonicalize(json.toJSON());
  }
  if (Array.isArray(json)) {
    let inner2 = json.map((item) => canonicalize(getValue(item))).join(",");
    return `[${inner2}]`;
  }
  let inner = Object.keys(json).sort().map((key) => `${canonicalize(key)}:${canonicalize(getValue(json[key]))}`).join(",");
  return `{${inner}}`;
};
export {
  canonicalize
};
//# sourceMappingURL=index.mjs.map